module.exports = __webpack_public_path__ + "assets/img/consideration-gestion-documentaire-traditionnel-vs-ged.ab57d9d8.jpg";